import moment from 'moment';

// import { format } from 'date-fns';
// import { ConfigService } from '../Configs/ConfigService';
// import { DateFormats, DateTimeFormats, TimeFormats } from './types/enum';
// import { DateTimeFormatsType } from './types/types';

export const formatTime24 = (str: string) => {
  if (str === '' || str === null || str === undefined) return '';
  else if (str.indexOf('T') > 0 || str.indexOf(' ') > 0) {
    let today = new Date(str);
    return moment(today).format('HH:mm');
  } else return str;
};

export const formatFullDate = (dateString: string, showYear: boolean = true, showWeekday: boolean = true) => {
  let date = new Date(dateString);
  let format = `${showWeekday ? 'dddd,' : ''} D MMMM ${showYear ? 'YYYY' : ''}`;
  return moment(date).format(format);
};

export const formatISODate = (date: string | Date) => {
  if (typeof date === 'string') {
    date = new Date(date);
  }

  return moment(date).format();
};

export const formatDateDMYYYY = (dateValue: Date) => {
  const day = dateValue.getDate();
  const month = dateValue.getMonth() + 1;
  const year = dateValue.getFullYear();
  const formattedDate = `${day}/${month}/${year}`;

  return formattedDate;
};

// To format date in custom formats
export const dateTimeToCustomFormat = (inputDate: string, formatStr: string = 'DD/MM/YYYY'): string =>
  moment(new Date(inputDate)).format(formatStr);

export const UTCToCustomFormat = (inputDate: string, formatStr: string = 'DD/MM/YYYY'): string => {
  return moment(inputDate).format(formatStr);
};

export const UTCToLocal = (dateString: string) => {
  return new Date(new Date(dateString + 'Z'));
};

export const formatInbodyDate = (dateStr : string) => {
  if (!dateStr || dateStr.length !== 14) return 'Invalid date';

  const year = parseInt(dateStr.slice(0, 4), 10);
  const month = parseInt(dateStr.slice(4, 6), 10) - 1; // 0-based month
  const day = parseInt(dateStr.slice(6, 8), 10);
  const hour = parseInt(dateStr.slice(8, 10), 10);
  const minute = parseInt(dateStr.slice(10, 12), 10);
  const second = parseInt(dateStr.slice(12, 14), 10);

  const date = new Date(year, month, day, hour, minute, second);

  if (isNaN(date.getTime())) {
    return 'Invalid date';
  }

  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};
